import React, {Component} from 'react'
import SystemLabelMasterCollection from 'collections/system_label_master_collection'

class SelectSyaryougaisunLength extends Component {

  handleChangeStart = (e) => {
    this.props.actions.changeSelectSyaryougaisunLengthStart({
      selectSyaryougaisunLengthStart: e.target.value,
    })
  }

  handleChangeFinish = (e) => {
    this.props.actions.changeSelectSyaryougaisunLengthFinish({
      selectSyaryougaisunLengthFinish: e.target.value,
    })
  }

  render() {
    const {  payload } = this.props.systemLabelMastersApi
    if (!payload) {return null}
    const systemLabelMasterCollection = new SystemLabelMasterCollection(payload)
    return (
      <div className='searchArea__item'>
        <h3 className='searchArea__title'>{TRUCKERS.LANG.ITEM.SYARYOUGAISUN_LENGTH}</h3>
        <div className='searchArea__item__half searchArea__item__inner'>
          <p className='selectWrap'>
            <select
              className='select'
              value={this.props.selectSyaryougaisunLengthStart}
              onChange={this.handleChangeStart}
            >
              <option value="">{TRUCKERS.LANG.ITEM.LIST_SEARCH.LOWER}</option>
              {
                systemLabelMasterCollection.getValueList('item','select_syaryougaisun_length').map(i => {
                  return <option key={i.get('label_key')} value={i.get('label_key')} >{i.getValueI18n()}</option>
                })
              }
            </select>
          </p>
          <p>〜</p>
          <p className='selectWrap'>
            <select
              className='select'
              value={this.props.selectSyaryougaisunLengthFinish}
              onChange={this.handleChangeFinish}
            >
              <option value="">{TRUCKERS.LANG.ITEM.LIST_SEARCH.UPPER}</option>
              {
                systemLabelMasterCollection.getValueList('item','select_syaryougaisun_length').map(i => {
                  return <option key={i.get('label_key')} value={i.get('label_key')} >{i.getValueI18n()}</option>
                })
              }
            </select>
          </p>
        </div>
      </div>
    )
  }
}
export default SelectSyaryougaisunLength
